import apiService from "./api";

export interface Orixa {
	id: string;
	name: string;
	color?: string | null;
	createdAt: string;
	updatedAt: string;
}

export interface CreateOrixaData {
	name: string;
	color?: string;
}

export interface UpdateOrixaData {
	name?: string;
	color?: string;
}

export interface OrixaDistribution {
	name: string;
	color: string | null;
	count: number;
}

export default {
	async getAll(): Promise<Orixa[]> {
		return apiService.get("/orixas");
	},

	async getById(id: string): Promise<Orixa> {
		return apiService.get(`/orixas/${id}`);
	},

	async create(data: CreateOrixaData): Promise<Orixa> {
		return apiService.post("/orixas", data);
	},

	async update(id: string, data: UpdateOrixaData): Promise<Orixa> {
		return apiService.patch(`/orixas/${id}`, data);
	},

	async delete(id: string): Promise<void> {
		await apiService.delete(`/orixas/${id}`);
	},

	async getDistribution(): Promise<OrixaDistribution[]> {
		return apiService.get("/orixas/distribution");
	},
};
